<template lang="pug">
  .tfooter
    .notice-mobile
      notice-block(
      type="warning",
      info="The results shown are omitting 1,385 historical results.",
      title="note",
      link="Show historical data")
    .additional-line
      .info-wrap
        font-awesome-icon.triangle.danger(icon="exclamation-triangle", size="lg")
        p.info The results shown are omitting 1,385 historical results.
      .link-wrap
        a.link.default-bold.w-6 Show historical data
</template>
<script>
import NoticeBlock from '../lei-components/NoticeBlock'

export default {
  components: {
    NoticeBlock,
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"

  .tfooter
    .notice-mobile
      display none
    .additional-line
      font-size 80%
      display flex
      justify-content space-between
      align-items center
      border-radius 4px
      padding 10px 15px
      border 1px solid $warning-color-light-1
      background-color $warning-color-light-2
      .info-wrap
        display flex
        justify-content space-between
        align-items center
        .info
          color $default-color-bold
          margin 0 10px
      .link-wrap
        .link
          text-decoration underline

  @media screen and (max-width: $laptop)
    .tfooter
      order 3
      .additional-line
        display none
      .notice-mobile
        display block
        margin 0 -20px
</style>



// WEBPACK FOOTER //
// src/components/data-table/TFooter.vue